'use strict';

export function OrgMemberDomainProvider() {
  return {
    $get: ['FirebaseUtil', 'AbstractRelationClass',
      function (FirebaseUtil, AbstractRelationClass) {
        //console.log('Calling OrgMemberDomain');
        function OrgMemberDomain(data) {
          AbstractRelationClass.call(this, OrgMemberDomain, data);
        }

        AbstractRelationClass.__inheritFrom(OrgMemberDomain, 'OrgMemberDomain');

        OrgMemberDomain.$constraints.addConstraints({
          isActive: {type: 'boolean'},
          role: {type: 'string', inList: ['user', 'manager', 'admin', 'owner']},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'}
        });

        OrgMemberDomain.prototype.toString = function () {
          return (this.isActive && this.role) || 'Inactive'; // TODO: convert to message code?
        };

        return OrgMemberDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/organizations/domain/OrgMemberDomain.js